import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Icon } from '@node-space/ui-components'
import { ConditionalTooltip } from 'components/Conditional/ConditionalTooltip'
import { useProfileContext } from 'hooks/context/useProfileContext'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { RoleGroupMatchTypes, useHasRoleGroups } from 'hooks/useHasRoleGroups'
import { ROLES_REQUIRED_TO_ADD_CUSTOMER } from 'pages/Customers/constants'
import { AddCustomerAgreement } from './AddCustomerAgreement'

export interface AddCustomerAgreementCtaProps {
  refetchCustomers: () => void
}

export const AddCustomerAgreementCta = ({ refetchCustomers }: AddCustomerAgreementCtaProps) => {
  const { t } = useTranslation()
  const [isSheetOpen, setIsSheetOpen] = useState(false)
  const { profile } = useProfileContext()
  const { enableSelfCustodyReadonlyCustomers } = useFeatureFlags()

  const canAddCustomer = useHasRoleGroups(
    profile,
    ROLES_REQUIRED_TO_ADD_CUSTOMER,
    RoleGroupMatchTypes.SOME
  )

  if (enableSelfCustodyReadonlyCustomers) return null

  return (
    <>
      <ConditionalTooltip
        isEnabled={!canAddCustomer}
        bodyContent={t('customers.addNewCustomerNoPermission')}
      >
        <Button
          onClick={() => canAddCustomer && setIsSheetOpen(true)}
          name={t('customers.addNewCustomer')}
          iconElement={<Icon name="Plus" />}
          disabled={!canAddCustomer}
        >
          {t('customers.addNewCustomer')}
        </Button>
      </ConditionalTooltip>
      <AddCustomerAgreement
        isOpen={isSheetOpen}
        onClose={() => setIsSheetOpen(false)}
        onCustomerAdded={() => {
          refetchCustomers()
          setIsSheetOpen(false)
        }}
      />
    </>
  )
}
